module.exports = __webpack_public_path__ + "static/media/profile-9.f27aa0e6.jpeg";